import { useIntl } from 'react-intl';

import ContourBackdrop from '../../components/ContourBackdrop/ContourBackdrop';
import styles from './TermsAndConditions.module.css';

const CONTACT_EMAIL = 'contact@finpath.am';

// The mockup's nine numbered sections: a heading followed by its bullets. The
// numbering lives in the translations, so a locale can punctuate it its own way.
const SECTIONS = [
	{ title: 'TermsandConditionsId5', items: ['TermsandConditionsId6'] },
	{ title: 'TermsandConditionsId7', items: ['TermsandConditionsId8'] },
	{
		title: 'TermsandConditionsId9',
		items: ['TermsandConditionsId10', 'TermsandConditionsId11'],
	},
	{
		title: 'TermsandConditionsId12',
		items: [
			'TermsandConditionsId13',
			'TermsandConditionsId14',
			'TermsandConditionsId15',
		],
	},
	{
		title: 'TermsandConditionsId16',
		items: [
			'TermsandConditionsId17',
			'TermsandConditionsId18',
			'TermsandConditionsId19',
		],
	},
	{
		title: 'TermsandConditionsId20',
		items: ['TermsandConditionsId21', 'TermsandConditionsId22'],
	},
	{
		title: 'TermsandConditionsId23',
		items: ['TermsandConditionsId24', 'TermsandConditionsId25'],
	},
	{ title: 'TermsandConditionsId26', items: ['TermsandConditionsId27'] },
	{
		title: 'TermsandConditionsId28',
		items: ['TermsandConditionsId29'],
		// The last bullet ends with the address to write to.
		email: true,
	},
];

const Terms = () => {
	const intl = useIntl();

	return (
		<div className={styles.page}>
			<main className={styles.main}>
				<section className={styles.section}>
					<ContourBackdrop
						className={styles.contoursRight}
						rings={7}
						from={3.4}
					/>
					<ContourBackdrop
						className={styles.contoursLeft}
						rings={7}
						from={3.4}
					/>

					<div className={styles.container}>
						<div className={styles.header}>
							<h1 className={styles.title}>
								{intl.formatMessage({ id: 'TermsandConditionsId2' })}
							</h1>
							<p className={styles.lead}>
								{intl.formatMessage({ id: 'TermsandConditionsId1' })}
							</p>
						</div>

						<div className={styles.doc}>
							{SECTIONS.map(({ title, items, email }) => (
								<section key={title} className={styles.block}>
									<h2 className={styles.blockTitle}>
										{intl.formatMessage({ id: title })}
									</h2>
									<ul className={styles.list}>
										{items.map((id, index) => (
											<li key={id}>
												{intl.formatMessage({ id })}
												{email && index === items.length - 1 && (
													<>
														{' '}
														<a
															className={styles.mail}
															href={`mailto:${CONTACT_EMAIL}`}
														>
															{CONTACT_EMAIL}
														</a>
													</>
												)}
											</li>
										))}
									</ul>
								</section>
							))}
						</div>
					</div>
				</section>
			</main>
		</div>
	);
};

export default Terms;
